(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 83754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _fp = __webpack_require__(78230);
var _lodash = _interopRequireDefault(__webpack_require__(96486));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * @param {Array} portableTexts - Array of portable text objects to join.
 * @param {string} delimiter - String to delimit the values when joining. Defaults to ' '.
 *
 * @returns {object} - A portable text object with type 'block', and value containing joined portable texts.
 */
var joinPortableText = function joinPortableText(portableTexts, delimiter) {
  var spacer = {
    type: 'span',
    value: delimiter || ' '
  };
  return {
    type: 'block',
    value: _lodash["default"].flatMap(portableTexts, function (portableText, index, array) {
      // If the portable text object passed in is a parent, join its children. Otherwise, join the object itself.
      var portableTextToJoin = (0, _fp.isObject)(portableText.value) ? portableText.value : portableText;
      return (0, _fp.size)(array) - 1 !== index ? (0, _fp.concat)(portableTextToJoin, spacer) : portableTextToJoin;
    })
  };
};
var _default = exports["default"] = joinPortableText;
module.exports = exports.default;

/***/ }),

/***/ 1866:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
Object.defineProperty(exports, "Z", ({
    enumerable: true,
    get: function() {
        return _default;
    }
}));
var _getallrewards = /*#__PURE__*/ _interop_require_default(__webpack_require__(19722));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var getAllRewards = (0, _getallrewards.default)();
var _default = getAllRewards;


/***/ }),

/***/ 55105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const lodash_1 = __importDefault(__webpack_require__(96486));
const assert_1 = __importDefault(__webpack_require__(27596));
const constants_1 = __webpack_require__(13294);
const LISTED_PRODUCT_TYPE_PATHS = {
    combined: 'hospital-extras-bundle',
    extras: 'extras-cover',
    hospital: 'hospital-cover',
    package: 'hospital-extras-packages',
};
function getProductUrl(args) {
    const { errorUrl, productId, rawUrl } = args || { errorUrl: undefined, productId: undefined, rawUrl: undefined };
    (0, assert_1.default)(lodash_1.default.isString(rawUrl), 'rawUrl must be a string');
    (0, assert_1.default)(lodash_1.default.isString(productId), 'productId must be a string');
    (0, assert_1.default)(lodash_1.default.isString(errorUrl), 'errorUrl must be a string');
    const type = lodash_1.default.findKey(constants_1.PRODUCTS_BY_TYPE, (products) => lodash_1.default.includes(products, productId));
    const parentProductId = lodash_1.default.findKey(constants_1.PRODUCTS_BY_PARENT, (products) => lodash_1.default.includes(products, productId));
    if (lodash_1.default.isUndefined(type) || lodash_1.default.isUndefined(productId)) {
        return errorUrl;
    }
    const productUrl = (0, lodash_1.default)(rawUrl)
        .replace(':type', LISTED_PRODUCT_TYPE_PATHS[type])
        .replace(':id', parentProductId || lodash_1.default.replace(productId, /(\b-excess-)[0-9]*/, ''));
    return productUrl;
}
module.exports = {
    getProductUrl,
};


/***/ }),

/***/ 34650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ setContext; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _core_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81707);
/* harmony import */ var _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94248);



function setContext(setter) {
    return new _core_index_js__WEBPACK_IMPORTED_MODULE_0__.ApolloLink(function (operation, forward) {
        var request = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(operation, []);
        return new _utilities_index_js__WEBPACK_IMPORTED_MODULE_1__/* .Observable */ .y$(function (observer) {
            var handle;
            Promise.resolve(request)
                .then(function (req) { return setter(req, operation.getContext()); })
                .then(operation.setContext)
                .then(function () {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            })
                .catch(observer.error.bind(observer));
            return function () {
                if (handle)
                    handle.unsubscribe();
            };
        });
    });
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(40862);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ WrappedPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/client/models/table-of-contents/constants/index.ts
var constants = __webpack_require__(3971);
// EXTERNAL MODULE: ./utils/growth-book/index.tsx
var growth_book = __webpack_require__(69076);
// EXTERNAL MODULE: ./src/client/utils/get-should-skip-client-side-request/index.ts
var get_should_skip_client_side_request = __webpack_require__(14033);
// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__(14890);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js + 5 modules
var esm = __webpack_require__(81361);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/client/utils/cookie-for-members/index.ts
var cookie_for_members = __webpack_require__(64944);
// EXTERNAL MODULE: ./src/client/ahm-constants/ui.ts
var ui = __webpack_require__(93590);
// EXTERNAL MODULE: ./src/client/contexts/cookie/index.ts
var cookie = __webpack_require__(3502);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/awards/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1rem;\n\n  @media (min-width: ",
        ") {\n    font-size: 1.25rem;\n    line-height: 1.5rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 2rem;\n  margin: 1rem;\n\n  @media (min-width: ",
        ") {\n    margin: 2rem 1rem;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 4.75rem;\n  object-fit: contain;\n  padding: inherit;\n\n  @media (min-width: ",
        ") {\n    height: 8.75rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin: auto;\n  align-items: flex-start;\n\n  @media (min-width: ",
        ") {\n    align-items: center;\n    flex-direction: row;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-7b5c1a26-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.xs;
});
var StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-7b5c1a26-1"
})(_templateObject1());
var StyledImageWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-7b5c1a26-2"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var StyledImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-7b5c1a26-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var StyledWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-7b5c1a26-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});

// EXTERNAL MODULE: ./src/client/components/awards/data/awards.ts + 2 modules
var awards = __webpack_require__(85245);
;// CONCATENATED MODULE: ./src/client/components/awards/index.tsx






var calloutLink = awards/* default.callout.to */.Z.callout.to;
var calloutText = awards/* default.callout.text */.Z.callout.text;
var hasCallout = calloutLink && calloutText;
var Awards = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
        isBoxed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
            df: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
                variant: [
                    "marginTopSpacer9",
                    "marginBottomSpacer9"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImageWrapper, {
                        children: (0,fp.map)(function(param) {
                            var alt = param.alt, imageSrc = param.imageSrc, label = param.label, to = param.to;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
                                to: to,
                                analytics: {
                                    label: label
                                },
                                "aria-label": label,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                    src: imageSrc,
                                    alt: alt
                                })
                            }, label);
                        }, awards/* default.images */.Z.images)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                looksLike: "h3",
                                variant: [
                                    "simpleBit",
                                    hasCallout && "marginBottomSpacer9"
                                ],
                                children: awards/* default.blurb */.Z.blurb
                            }),
                            hasCallout && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledClickable, {
                                to: calloutLink,
                                variant: [
                                    "bold",
                                    "outlineDarkBg"
                                ],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                    children: calloutText
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_awards = (Awards);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/client/cms/utils/get-image-attributes/index.ts
var get_image_attributes = __webpack_require__(51413);
// EXTERNAL MODULE: ./src/client/utils/get-link-for-explained-term/index.ts
var get_link_for_explained_term = __webpack_require__(78687);
;// CONCATENATED MODULE: ./src/client/pages/home/components/content-tiles/utils/map-content/index.ts



var mapContent = function(items) {
    return (0,fp.flow)((0,fp.map)(function(item) {
        if (!(0,fp.isPlainObject)(item)) {
            return null;
        }
        var ref = (0,fp.pick)([
            "_id",
            "__typename",
            "name",
            "sloganRaw",
            "descriptionRaw",
            "imageObject",
            "summaryRaw"
        ], item), _id = ref._id, __typename = ref.__typename, name = ref.name, sloganRaw = ref.sloganRaw, descriptionRaw = ref.descriptionRaw, imageObject = ref.imageObject, summaryRaw = ref.summaryRaw;
        var mandatoryFieldsMissing = __typename === "ExplainedTerm" ? (0,fp.some)(fp.isEmpty, [
            _id,
            sloganRaw,
            imageObject,
            summaryRaw
        ]) : (0,fp.some)(fp.isEmpty, [
            _id,
            descriptionRaw
        ]) && (0,fp.every)(fp.isEmpty, [
            name,
            sloganRaw
        ]);
        if (mandatoryFieldsMissing) {
            return null;
        }
        var image = (0,get_image_attributes/* default */.Z)({
            height: 240,
            imageObject: imageObject
        });
        var ctaObject = (0,fp.compact)([
            (0,get_link_for_explained_term/* default */.Z)(item)
        ]);
        return {
            _id: _id,
            ctas: ctaObject,
            image: image,
            subtitle: __typename === "ExplainedTerm" ? summaryRaw : descriptionRaw,
            title: (0,fp.isEmpty)(sloganRaw) ? name : sloganRaw
        };
    }), fp.compact)(items);
};
/* harmony default export */ var map_content = (mapContent);

// EXTERNAL MODULE: ./src/client/utils/sort-tiles/index.ts
var sort_tiles = __webpack_require__(2112);
;// CONCATENATED MODULE: ./src/client/pages/home/components/content-tiles/index.tsx








var ContentTiles = function(param) {
    var items = param.items;
    var tiles = map_content((0,fp.map)("item", items));
    var sortedChunkedTiles = (0,sort_tiles/* default */.Z)(tiles, ui.TILE_VARIANTS.VERTICAL);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: (0,fp.map)(function(chunk) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: (0,fp.map)(function(tile) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: true,
                        md: 12 / chunk.length,
                        sm: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* ContentTile */.Jm, (0,_object_spread/* default */.Z)({}, tile))
                    }, (0,fp.get)("_id", tile));
                }, chunk)
            }, (0,fp.get)("_id", (0,fp.head)(chunk)));
        }, sortedChunkedTiles)
    });
};
/* harmony default export */ var content_tiles = (ContentTiles);

// EXTERNAL MODULE: ./src/client/components/sections/features-section/index.tsx + 3 modules
var features_section = __webpack_require__(84244);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
;// CONCATENATED MODULE: ./src/client/pages/home/data/index.ts

var diversifiedHeroData = {
    urlObject: {
        name: "Manage your health cover",
        url: ahm_constants/* default.URLS.MEMBERS.HOME */.Z.URLS.MEMBERS.HOME
    }
};
var heroSectionData = {
    urlObject: {
        name: "Find cover",
        url: ahm_constants/* default.URLS.SALES.REFINE_PRICE */.Z.URLS.SALES.REFINE_PRICE
    }
};

;// CONCATENATED MODULE: ./src/client/pages/home/utils/get-hero-section-content/index.ts




var getBannerProps = function(content) {
    var bannerContent = (0,fp.get)("banners", content);
    var ref = (0,_sliced_to_array/* default */.Z)((0,fp.map)(function(identifier) {
        return (0,fp.find)(function(banner) {
            return (0,fp.get)("identifier.current", banner) === identifier;
        }, bannerContent);
    }, [
        "home-default",
        "home-diversified"
    ]), 2), cmsDefaultBannerContent = ref[0], cmsDiversifiedBannerContent = ref[1];
    return {
        diversifiedHeroProps: (0,_object_spread/* default */.Z)({}, diversifiedHeroData, cmsDiversifiedBannerContent),
        heroSectionProps: (0,_object_spread/* default */.Z)({}, heroSectionData, cmsDefaultBannerContent)
    };
};
/* harmony default export */ var get_hero_section_content = (getBannerProps);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/icons-web/lib/index.js
var lib = __webpack_require__(54312);
// EXTERNAL MODULE: ./src/client/logging/index.ts
var logging = __webpack_require__(99846);
;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-section-tile/index.tsx

function hero_section_tile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1;\n  grid-template-rows: 10fr auto 7fr auto;\n  align-items: start;\n  grid-gap: 3px;\n  text-align: center;\n\n  @media (min-width: ",
        ") {\n    text-align: left;\n    grid-template-columns: auto;\n  }\n"
    ]);
    hero_section_tile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hero_section_tile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100%;\n"
    ]);
    hero_section_tile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function hero_section_tile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 120px;\n  margin-bottom: 1rem;\n  object-fit: contain;\n  width: 120px;\n"
    ]);
    hero_section_tile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function hero_section_tile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 0;\n\n  @media (min-width: ",
        ") {\n    align-items: start;\n  }\n"
    ]);
    hero_section_tile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function hero_section_tile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 1.5rem;\n"
    ]);
    hero_section_tile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  word-wrap: normal;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}






var hero_section_tile_StyledDiv = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5ed8c5cc-0"
})(hero_section_tile_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5ed8c5cc-1"
})(hero_section_tile_templateObject1());
var hero_section_tile_StyledImage = (0,styled_components_browser_esm["default"])(ahm_ui/* Image */.Ee).withConfig({
    componentId: "sc-5ed8c5cc-2"
})(hero_section_tile_templateObject2());
var StyledBodyWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5ed8c5cc-3"
})(hero_section_tile_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
});
var hero_section_tile_StyledClickable = (0,styled_components_browser_esm["default"])(ahm_ui/* Clickable */.P3).withConfig({
    componentId: "sc-5ed8c5cc-4"
})(hero_section_tile_templateObject4());
var StyledDescription = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-5ed8c5cc-5"
})(_templateObject5());
var StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-5ed8c5cc-6"
})(_templateObject6());
var wrapDescription = function(description) {
    return (0,fp.isArray)(description) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
        source: description
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Markdown */.UG, {
        children: description
    });
};
var HeroSectionTile = function(props) {
    var propsToCheck = (0,fp.omit)("alt", props);
    if ((0,fp.some)(fp.isEmpty, propsToCheck)) {
        logging/* default.getLogger */.Z.getLogger().warn("HeroSectionTile: Missing props: ", propsToCheck);
    }
    var alt = props.alt, buttonLink = props.buttonLink, buttonName = props.buttonName, desc = props.desc, image = props.image, link = props.link, linkName = props.linkName, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(hero_section_tile_StyledDiv, {
        children: [
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section_tile_StyledImage, {
                    src: image,
                    alt: alt || undefined,
                    role: alt ? undefined : "presentation"
                })
            }),
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                variant: "simpleBit",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBodyWrapper, {
                children: [
                    desc && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescription, {
                        children: wrapDescription(desc)
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section_tile_StyledClickable, {
                        to: link,
                        children: linkName
                    })
                ]
            }),
            buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                to: buttonLink,
                variant: [
                    "transparentBlack",
                    "border"
                ],
                children: buttonName
            })
        ]
    });
};
/* harmony default export */ var hero_section_tile = (HeroSectionTile);

;// CONCATENATED MODULE: ./src/client/pages/home/components/diversified-hero/index.tsx



function diversified_hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n\n  @media (min-width: ",
        ") {\n    flex-direction: row;\n  }\n"
    ]);
    diversified_hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function diversified_hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  flex: 3;\n  justify-content: flex-start;\n"
    ]);
    diversified_hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function diversified_hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    diversified_hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function diversified_hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (min-width: ",
        ") {\n    flex: 1;\n    justify-content: space-between;\n  }\n"
    ]);
    diversified_hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function diversified_hero_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0.5rem;\n"
    ]);
    diversified_hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function diversified_hero_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 1.5rem;\n  word-wrap: normal;\n"
    ]);
    diversified_hero_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function diversified_hero_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-top: 2px dotted black;\n"
    ]);
    diversified_hero_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n\n  @media (min-width: ",
        ") {\n    margin: 0 2rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  gap: 3rem;\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  @media (min-width: ",
        ") {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}








var StyledTitleSection = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-743e57e7-0"
})(diversified_hero_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledH1 = (0,styled_components_browser_esm["default"])(ahm_ui.H1).withConfig({
    componentId: "sc-743e57e7-1"
})(diversified_hero_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontWeights.extraBold;
});
var StyledButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-743e57e7-2"
})(diversified_hero_templateObject2());
var diversified_hero_StyledButton = (0,styled_components_browser_esm["default"])(ahm_ui/* Button */.zx).withConfig({
    componentId: "sc-743e57e7-3"
})(diversified_hero_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var StyledIcon = (0,styled_components_browser_esm["default"])(lib["default"]).withConfig({
    componentId: "sc-743e57e7-4"
})(diversified_hero_templateObject4());
var StyledHeroSectionTile = (0,styled_components_browser_esm["default"])(hero_section_tile).withConfig({
    componentId: "sc-743e57e7-5"
})(diversified_hero_templateObject5());
var StyledHR = styled_components_browser_esm["default"].hr.withConfig({
    componentId: "sc-743e57e7-6"
})(diversified_hero_templateObject6());
var StyledSpacerWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-743e57e7-7"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.media.md;
});
var GridWrapper = (0,styled_components_browser_esm["default"])(ahm_ui/* SpacerWrapper */.Cj).withConfig({
    componentId: "sc-743e57e7-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.media.sm;
}, function(param) {
    var theme = param.theme;
    return theme.media.lg;
});
var getTilesContent = function(tiles) {
    return (0,fp.map)(function(insuranceType) {
        return {
            alt: (0,fp.get)("tileImage.caption", insuranceType),
            buttonLink: (0,fp.get)("rootUrl", insuranceType),
            buttonName: "Get a quote",
            desc: (0,fp.get)("offer.[0].description", insuranceType),
            image: (0,fp.get)("tileImage.image.asset.url", insuranceType),
            link: (0,fp.get)("termsAndConditionsUrl", insuranceType),
            linkName: "See terms",
            title: (0,fp.get)("name", insuranceType)
        };
    }, tiles);
};
var DiversifiedHero = function(param) {
    var name = param.name, urlObject = param.urlObject, listItems = param.listItems;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var tilesContent = getTilesContent(listItems);
    var hasCta = (0,fp.get)("url", urlObject) && (0,fp.get)("name", urlObject);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
        isBoxed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, {
            df: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSpacerWrapper, {
                    variant: [
                        "marginBottomSpacer10",
                        "marginTopSpacer4"
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitleSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledH1, {
                                    children: name
                                }),
                                hasCta && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(diversified_hero_StyledButton, {
                                        to: (0,fp.get)("url", urlObject),
                                        variant: "purple",
                                        children: [
                                            (0,fp.get)("name", urlObject),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIcon, {
                                                name: "chevron-right",
                                                fill: "CurrentColor"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHR, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpacerWrapper, {
                    variant: [
                        "marginBottomSpacer3",
                        "marginTopSpacer4"
                    ],
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridWrapper, {
                        children: (0,fp.map)(function(tileContent) {
                            return /*#__PURE__*/ (0,react.createElement)(StyledHeroSectionTile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tileContent), {
                                key: tilesContent.indexOf(tileContent)
                            }));
                        })(tilesContent)
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var diversified_hero = (DiversifiedHero);

// EXTERNAL MODULE: ./node_modules/@ahmdigital/offers/lib/model/offer/get-all-rewards/index.js
var get_all_rewards = __webpack_require__(1866);
// EXTERNAL MODULE: ./src/client/utils/filter-offers-by-product-type/index.ts
var filter_offers_by_product_type = __webpack_require__(41763);
// EXTERNAL MODULE: ./src/client/components/offers/tile/utils/get-content-for-offer/index.ts
var get_content_for_offer = __webpack_require__(95897);
// EXTERNAL MODULE: ./src/client/components/offers/tile/components/offer-heading/index.tsx
var offer_heading = __webpack_require__(34194);
// EXTERNAL MODULE: ./src/client/components/offers/images/offer-tag.svg
var offer_tag = __webpack_require__(9788);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/logic/lib/content/utils/generate-portable-text/index.js
var generate_portable_text = __webpack_require__(5398);
var generate_portable_text_default = /*#__PURE__*/__webpack_require__.n(generate_portable_text);
;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-offer-section/components/rewards-list/index.tsx

function rewards_list_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 0.375rem;\n  @media (min-width: ",
        ") {\n    max-width: 47vw; // This prevents overlap with the hero background image\n  }\n"
    ]);
    rewards_list_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function rewards_list_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0.375rem;\n"
    ]);
    rewards_list_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var PortableTextForList = (0,styled_components_browser_esm["default"])(ahm_ui/* PortableText */.YI).withConfig({
    componentId: "sc-a5379d1c-0"
})(rewards_list_templateObject(), ahm_ui/* theme.media.sm */.rS.media.sm);
var PortableTextForTerms = (0,styled_components_browser_esm["default"])(PortableTextForList).withConfig({
    componentId: "sc-a5379d1c-1"
})(rewards_list_templateObject1());
var subtextToListItems = function(subtextValue) {
    if ((0,fp.isEmpty)(subtextValue)) return null;
    return {
        fill: ahm_ui/* theme.colors.green */.rS.colors.green,
        icon: "tick-circle",
        text: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableTextForList, {
            source: generate_portable_text_default()({
                value: subtextValue
            })
        })
    };
};
var RewardsList = function(param) {
    var sublist = param.sublist, ends = param.ends;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            sublist && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* IconList */.Zd, {
                items: (0,fp.compact)((0,fp.map)(subtextToListItems, sublist.value)),
                variant: "simple"
            }),
            ends && /*#__PURE__*/ (0,jsx_runtime.jsx)(PortableTextForTerms, {
                source: generate_portable_text_default()(ends)
            })
        ]
    });
};
/* harmony default export */ var rewards_list = (RewardsList);

;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-offer-section/index.tsx




// @ts-expect-error - Automatic, Please fix when editing this file








var HeroOfferSection = function(param) {
    var activeOffers = param.activeOffers, isPartnerReferral = param.isPartnerReferral, lastViewedProduct = param.lastViewedProduct, placeholders = param.placeholders;
    var isHomepageOfferBannerEnabled = (0,esm/* useFeatureIsOn */.cC)(ui.GROWTHBOOK_HOMEPAGE_OFFER_BANNER);
    if ((0,fp.isEmpty)(activeOffers) || !isHomepageOfferBannerEnabled || isPartnerReferral) {
        return null;
    }
    var lastViewedProductType = lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.type;
    // @ts-expect-error - Automatic, Please fix when editing this file
    var offer = (0,filter_offers_by_product_type/* default */.Z)(lastViewedProductType, activeOffers);
    var ref = (0,get_content_for_offer/* default */.Z)(offer), ends = ref.ends, header = ref.header, sublist = ref.sublist;
    var rewards = (0,get_all_rewards/* default */.Z)(offer);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Section */.$0, {
        variant: "paddingBottomSpacer9",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                src: offer_tag/* default.src */.Z.src,
                alt: "Offer"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                variant: "marginBottomSpacer12",
                looksLike: "h3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_heading/* default */.Z, {
                    offer: offer,
                    placeholders: placeholders,
                    rewards: rewards,
                    header: header
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(rewards_list, {
                sublist: sublist,
                ends: ends
            })
        ]
    });
};
/* harmony default export */ var hero_offer_section = (HeroOfferSection);

;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-section/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2.5rem 0 3.5rem;\n\n  ",
        "\n\n  .flair {\n    .ctaLink {\n      color: $color-purple;\n    }\n  }\n\n  /* offer section */\n  section {\n    padding-top: 1rem;\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledSection = (0,styled_components_browser_esm["default"])(ahm_ui/* Section */.$0).withConfig({
    componentId: "sc-15c60ef7-0"
})(styles_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    @media (min-width: ".concat(theme.media.sm, ") {\n      padding: 2.5rem 2rem;\n    }\n\n    @media (min-width: ").concat(theme.media.md, ") {\n      max-width: 55rem;\n      padding: 6rem 2rem;\n    }\n  ");
});
var StyledCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-15c60ef7-1"
})(styles_templateObject1(), function(param) {
    var theme = param.theme;
    return "\n    @media (min-width: ".concat(theme.media.md, ") {\n      flex-direction: row;\n    }\n  ");
});
var DesktopVideoWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-15c60ef7-2"
})(styles_templateObject2(), function(param) {
    var theme = param.theme, $extraTopMargin = param.$extraTopMargin;
    return "\n    @media (min-width: ".concat(theme.media.md, ") {\n      margin-top: ").concat($extraTopMargin ? "13rem" : "5rem", ";\n      margin-bottom: 5rem;\n      display: block;\n      text-align: center;\n      width: 45%;\n    }\n  ");
});
var Cta = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-15c60ef7-3"
})(styles_templateObject3(), function(param) {
    var theme = param.theme, $extraTopMargin = param.$extraTopMargin;
    return "\n    @media (max-width: ".concat(theme.media.md, ") {\n      margin-top: ").concat($extraTopMargin ? "3rem" : 0, ";\n    }\n  ");
});

;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-section/index.tsx






var getCtaComponent = function(urlObject) {
    var url = urlObject.url, name = urlObject.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
        icon: {
            name: "arrow-right-long",
            position: "right",
            size: "large"
        },
        to: url,
        variant: [
            "flair",
            "wide",
            "wideSpaceBetween"
        ],
        children: name
    });
};
var HeroSection = function(param) {
    var heroOfferSection = param.heroOfferSection, name = param.name, subtitle = param.subtitle, urlObject = param.urlObject;
    var activeOffers = (0,fp.get)("props.activeOffers", heroOfferSection);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
        isBoxed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCol, {
            df: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSection, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                            children: name
                        }),
                        !(0,fp.isEmpty)(subtitle) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Hidden */._G, {
                            xs: true,
                            sm: true,
                            md: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                                looksLike: "h6",
                                variant: [
                                    "regular",
                                    "paddingBottomSpacer10"
                                ],
                                children: subtitle
                            })
                        }),
                        heroOfferSection,
                        urlObject && /*#__PURE__*/ (0,jsx_runtime.jsx)(Cta, {
                            $extraTopMargin: (0,fp.isNil)(activeOffers),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                                sm: 12,
                                md: 6,
                                children: getCtaComponent(urlObject)
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopVideoWrapper, {
                    $extraTopMargin: !(0,fp.isNil)(activeOffers),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        playsInline: true,
                        height: "400px",
                        width: "340px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                            src: ui.SANITY_MEDIA_FILES.GLITCH_VIDEO,
                            type: "video/mp4"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var hero_section = (HeroSection);

;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-section/background-image/index.tsx

function background_image_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-origin: content-box;\n  background-repeat: no-repeat;\n\n  ",
        "\n"
    ]);
    background_image_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var BackgroundImage = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className,
        children: children
    });
};
var StyledBackgroundImage = (0,styled_components_browser_esm["default"])(BackgroundImage).withConfig({
    componentId: "sc-65c3aab9-0"
})(background_image_templateObject(), function(param) {
    var desktop = param.desktop, tablet = param.tablet, theme = param.theme;
    return "\n    @media (min-width: ".concat(theme.media.sm, ") {\n      background-image: url('").concat(tablet.image, "');\n      background-position: right 5% bottom 30%;\n      background-size: 17rem;\n    }\n\n    @media (min-width: ").concat(theme.media.md, ") {\n      background-image: url('").concat(desktop.image, "');\n      background-position: right 10% bottom 40%;\n      background-size: 22rem;\n    }\n  ");
});
/* harmony default export */ var background_image = (StyledBackgroundImage);

;// CONCATENATED MODULE: ./src/client/pages/home/components/welcome-back-hero/images/confetti-large.png
/* harmony default export */ var confetti_large = ({"src":"/_next/static/media/confetti-large.e42ac6cd.png","height":480,"width":713,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAAAAABd+vKJAAAAI0lEQVR42i2IwQkAMBCDsv/Op/VRElAccI3FfszkFzSdguADfLgnsDAP7jcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/client/pages/home/components/welcome-back-hero/images/confetti-small.png
/* harmony default export */ var confetti_small = ({"src":"/_next/static/media/confetti-small.547e07ea.png","height":376,"width":375,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAMklEQVR42h3IyQnAMADEwO2/43gPBRs9BCOn302nWdjR1wCNPDZcuYwR+d1W2cZ85dEP4oo/QyMEblYAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./src/client/components/price-disclaimer/index.tsx + 2 modules
var price_disclaimer = __webpack_require__(76383);
;// CONCATENATED MODULE: ./src/client/pages/home/components/hero-price-disclaimer/index.tsx

function hero_price_disclaimer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 3rem auto;\n"
    ]);
    hero_price_disclaimer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function hero_price_disclaimer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n"
    ]);
    hero_price_disclaimer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var hero_price_disclaimer_StyledCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-79403128-0"
})(hero_price_disclaimer_templateObject());
var StyledDisclaimer = (0,styled_components_browser_esm["default"])(price_disclaimer/* default */.ZP).withConfig({
    componentId: "sc-79403128-1"
})(hero_price_disclaimer_templateObject1());
var HeroPriceDisclaimer = function(param) {
    var product = param.product;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_price_disclaimer_StyledCol, {
            sm: 12,
            df: 10,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDisclaimer, {
                bold: true,
                forProducts: (0,fp.isEmpty)(product) ? undefined : [
                    product
                ],
                highlightIncome: true
            })
        })
    });
};
/* harmony default export */ var hero_price_disclaimer = (HeroPriceDisclaimer);

// EXTERNAL MODULE: ./src/client/utils/prepare-product-for-product-tile/index.ts
var prepare_product_for_product_tile = __webpack_require__(59794);
// EXTERNAL MODULE: ./src/client/selectors/select-customer/index.ts + 2 modules
var select_customer = __webpack_require__(34112);
;// CONCATENATED MODULE: ./src/client/pages/home/components/welcome-back-hero/index.tsx



function welcome_back_hero_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    welcome_back_hero_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function welcome_back_hero_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 311px;\n  background-color: white;\n  margin-top: 3.5rem;\n"
    ]);
    welcome_back_hero_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function welcome_back_hero_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    welcome_back_hero_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function welcome_back_hero_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  margin-bottom: 2rem;\n"
    ]);
    welcome_back_hero_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function welcome_back_hero_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    welcome_back_hero_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}














var StyledRow = (0,styled_components_browser_esm["default"])(ahm_ui/* Row */.X2).withConfig({
    componentId: "sc-45458cd6-0"
})(welcome_back_hero_templateObject(), function(param) {
    var theme = param.theme;
    return "\n    @media (min-width: ".concat(theme.media.md, ") {\n      padding-left: 2rem;\n      padding-right: 1rem;\n    }\n  ");
});
var CardWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-45458cd6-1"
})(welcome_back_hero_templateObject1());
var CardHolder = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-45458cd6-2"
})(welcome_back_hero_templateObject2());
var HeadingCol = (0,styled_components_browser_esm["default"])(ahm_ui/* Col */.JX).withConfig({
    componentId: "sc-45458cd6-3"
})(welcome_back_hero_templateObject3());
var welcome_back_hero_StyledBackgroundImage = (0,styled_components_browser_esm["default"])(background_image).withConfig({
    componentId: "sc-45458cd6-4"
})(welcome_back_hero_templateObject4(), function(param) {
    var mobile = param.mobile, theme = param.theme;
    return "\n    background-image: url('".concat(mobile === null || mobile === void 0 ? void 0 : mobile.image, "');\n    background-position: ").concat(mobile === null || mobile === void 0 ? void 0 : mobile.position, ";\n    background-size: auto 80%;\n\n    @media (min-width: ").concat(theme.media.sm, ") {\n      background-size: auto 90%;\n    }\n\n    @media (min-width: ").concat(theme.media.md, ") {\n      background-size: cover;\n    }\n  ");
});
var WelcomeBackHeroSection = function(param) {
    var customer = param.customer, heroOfferSection = param.heroOfferSection, isLoadingPrice = param.isLoadingPrice, lastViewedProduct = param.lastViewedProduct, prices = param.prices, useFutureEffectiveDate = param.useFutureEffectiveDate;
    var productName = (0,fp.get)("name", lastViewedProduct);
    var blurb = (0,fp.get)("content.longForm", lastViewedProduct);
    var tileProduct = (0,prepare_product_for_product_tile/* default */.Z)({
        customer: customer,
        frequency: customer.frequency,
        mlsAmount: undefined,
        prices: prices,
        useFutureEffectiveDate: useFutureEffectiveDate
    })(lastViewedProduct);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
        isBoxed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
            df: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Section */.$0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledRow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeadingCol, {
                                df: 6,
                                md: 12,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H1, {
                                        children: "Welcome back!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui.P, {
                                        looksLike: "h4",
                                        variant: "regular",
                                        children: [
                                            "Pick up where you left off with ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Strong */.cK, {
                                                children: productName
                                            })
                                        ]
                                    }),
                                    heroOfferSection
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                                df: 6,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_back_hero_StyledBackgroundImage, {
                                    desktop: {
                                        image: confetti_large.src,
                                        position: "left -50px top"
                                    },
                                    tablet: {
                                        image: confetti_small.src,
                                        position: "top"
                                    },
                                    mobile: {
                                        image: confetti_small.src,
                                        position: "top"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHolder, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardWrapper, {
                                            children: tileProduct && /*#__PURE__*/ (0,react.createElement)(ahm_ui/* ProductTile */.vB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,fp.omit)([
                                                "url",
                                                "content"
                                            ], tileProduct)), {
                                                name: tileProduct.name,
                                                nameVariant: "h5",
                                                additionalDetails: tileProduct.additionalDetails,
                                                ctaText: tileProduct.ctaText,
                                                secondaryCta: {
                                                    link: ahm_constants/* default.URLS.SALES.FIND_HEALTH_INSURANCE */.Z.URLS.SALES.FIND_HEALTH_INSURANCE,
                                                    text: "Find something else"
                                                },
                                                ctaVariant: [
                                                    "purple"
                                                ],
                                                linkTo: tileProduct.url,
                                                blurb: blurb,
                                                key: tileProduct.id,
                                                id: tileProduct.id,
                                                isLoadingPrice: isLoadingPrice,
                                                price: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tileProduct.price), {
                                                    props: {
                                                        variant: "extraLargeText"
                                                    }
                                                }),
                                                showBoxShadow: true
                                            }))
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_price_disclaimer, {
                        product: lastViewedProduct
                    })
                ]
            })
        })
    });
};
var mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        isLoadingPrice: state.price.loading,
        prices: state.price.data,
        useFutureEffectiveDate: state.price.useFutureEffectiveDate
    };
};
/* harmony default export */ var welcome_back_hero = ((0,es/* connect */.$j)(mapStateToProps)(WelcomeBackHeroSection));

;// CONCATENATED MODULE: ./src/client/pages/home/utils/get-home-hero/index.tsx








var getHomeHero = function(param) {
    var diversifiedHeroProps = param.diversifiedHeroProps, heroSectionProps = param.heroSectionProps, lastViewedProduct = param.lastViewedProduct, lastViewedProductId = param.lastViewedProductId, memberNumber = param.memberNumber, offerProps = param.offerProps, isPartnerReferral = param.isPartnerReferral;
    if (memberNumber) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(diversified_hero, (0,_object_spread/* default */.Z)({}, diversifiedHeroProps));
    }
    var heroOfferSection = // @ts-expect-error - Automatic, Please fix when editing this file
    /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_offer_section, (0,_object_spread/* default */.Z)({
        lastViewedProduct: lastViewedProduct,
        isPartnerReferral: isPartnerReferral
    }, offerProps));
    if (lastViewedProductId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(welcome_back_hero, {
            heroOfferSection: heroOfferSection,
            lastViewedProduct: lastViewedProduct
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(hero_section, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroSectionProps), {
        heroOfferSection: heroOfferSection
    }));
};
/* harmony default export */ var get_home_hero = (getHomeHero);

// EXTERNAL MODULE: ./src/client/components/offers/tile/index.tsx + 10 modules
var tile = __webpack_require__(24329);
// EXTERNAL MODULE: ./src/client/cms/utils/perks/build-cta-props/index.ts
var build_cta_props = __webpack_require__(62457);
// EXTERNAL MODULE: ./src/client/components/offers/tile/components/header-with-subtext/index.tsx
var header_with_subtext = __webpack_require__(73318);
// EXTERNAL MODULE: ./src/client/pages/home/components/perk-tile/styles.module.sass
var styles_module = __webpack_require__(54870);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/@apollo/client/core/index.js
var core = __webpack_require__(71439);
// EXTERNAL MODULE: ./node_modules/@apollo/client/index.js
var client = __webpack_require__(46829);
// EXTERNAL MODULE: ./src/client/cms/constants/index.ts
var cms_constants = __webpack_require__(28937);
// EXTERNAL MODULE: ./src/client/cms/utils/unique-content-with-draft-precedence/index.ts
var unique_content_with_draft_precedence = __webpack_require__(92002);
;// CONCATENATED MODULE: ./src/client/pages/home/components/perk-tile/use-get-perk/index.ts

function use_get_perk_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query getMemberPerk($id: String) {\n    allMemberPerk(where: { identifier: { current: { eq: $id } } }) {\n        descriptionTeaser\n        _id\n        id: _id\n        ",
        "\n        name\n        ",
        "\n        slogan\n        ",
        "\n        ",
        "\n    }\n  }\n"
    ]);
    use_get_perk_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GET_PERK = (0,core.gql)(use_get_perk_templateObject(), cms_constants/* GRAPHQL.IMAGE_OBJECT */.gQ.IMAGE_OBJECT, cms_constants/* GRAPHQL.RELEASE */.gQ.RELEASE, cms_constants/* GRAPHQL.SLUG */.gQ.SLUG, cms_constants/* GRAPHQL.URL_OBJECT */.gQ.URL_OBJECT);
// @ts-expect-error - Automatic, Please fix when editing this file
var useGetPerk = function(perkId) {
    var response = (0,client.useQuery)(GET_PERK, {
        variables: {
            id: perkId
        }
    });
    var data = response.data;
    return (0,fp.head)((0,unique_content_with_draft_precedence/* default */.Z)((0,fp.get)("allMemberPerk", data)));
};
/* harmony default export */ var use_get_perk = (useGetPerk);

;// CONCATENATED MODULE: ./src/client/pages/home/components/perk-tile/index.tsx











var PerkTile = function(param) {
    var perkId = param.perkId;
    var perk = use_get_perk(perkId);
    if ((0,fp.isNil)(perk)) {
        return null;
    }
    var image = (0,get_image_attributes/* default */.Z)({
        imageObject: perk === null || perk === void 0 ? void 0 : perk.imageObject,
        width: 400
    });
    var header = {
        type: "portableText",
        value: (0,fp.get)("name", perk)
    };
    var subtext = {
        type: "portableText",
        value: (0,fp.get)("slogan", perk)
    };
    var ctaProps = (0,build_cta_props/* default */.Z)(perk);
    var imageColProps = {
        df: 6,
        sm: 12
    };
    var copyColProps = (0,fp.mapValues)(function(width) {
        return width !== 12 ? 12 - width : 12;
    }, imageColProps);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
        isBoxed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
            df: 12,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: [
                    "paddingTopSpacer2",
                    "paddingBottomSpacer2",
                    (styles_module_default()).section
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Row */.X2, {
                    children: [
                        image ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: (styles_module_default()).imageWrapper
                        }, imageColProps), {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                                className: (styles_module_default()).image,
                                src: image.src,
                                alt: image.alt
                            })
                        }), "image") : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Col */.JX, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, copyColProps), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(header_with_subtext/* default */.Z, {
                                    header: header,
                                    subtext: subtext
                                }),
                                (0,fp.get)("ctaUrl", ctaProps) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                                        sm: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                                            to: ctaProps.ctaUrl,
                                            variant: [
                                                "border",
                                                "transparentBlack"
                                            ],
                                            children: ctaProps.ctaText
                                        })
                                    })
                                })
                            ]
                        }))
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var perk_tile = (PerkTile);

;// CONCATENATED MODULE: ./src/client/pages/home/utils/get-offer-or-perk-tile/index.tsx







var getOfferOrPerkTile = function(param) {
    var isHomepageOfferBannerEnabled = param.isHomepageOfferBannerEnabled, _isPartnerReferral = param.isPartnerReferral, isPartnerReferral = _isPartnerReferral === void 0 ? false : _isPartnerReferral, lastViewedProduct = param.lastViewedProduct, offerProps = param.offerProps, serverCookieValue = param.serverCookieValue;
    var isHealthMember = (0,fp.isPlainObject)((0,cookie_for_members/* getCookieForMembers */.a)("health", {
        serverCookieValue: serverCookieValue
    }));
    var isCarMember = (0,fp.isPlainObject)((0,cookie_for_members/* getCookieForMembers */.a)("car", {
        serverCookieValue: serverCookieValue
    }));
    var isHomeMember = (0,fp.isPlainObject)((0,cookie_for_members/* getCookieForMembers */.a)("home", {
        serverCookieValue: serverCookieValue
    }));
    var HomeInsuranceTile = /*#__PURE__*/ (0,jsx_runtime.jsx)(perk_tile, {
        perkId: "ahm-home-insurance"
    });
    var CarInsuranceTile = /*#__PURE__*/ (0,jsx_runtime.jsx)(perk_tile, {
        perkId: "ahm-car-insurance"
    });
    if (isHealthMember || isPartnerReferral) {
        if (isCarMember && isHomeMember) {
            return null;
        }
        if (isCarMember) {
            return HomeInsuranceTile;
        }
        if (isHomeMember) {
            return CarInsuranceTile;
        }
        return (0,fp.sample)((0,fp.compact)([
            HomeInsuranceTile,
            CarInsuranceTile
        ]));
    }
    var heading = "Check out our offers";
    var activeOffers = offerProps === null || offerProps === void 0 ? void 0 : offerProps.activeOffers;
    // If there is an offer being shown in the hero section of the home page, then strip that offer out
    // from the offers that will be shown in the home page offer tile.
    if (isHomepageOfferBannerEnabled && !(0,fp.isEmpty)(activeOffers)) {
        // If there is currently only one active offer, then it's already shown in the hero section
        // so no need to show it again
        if ((0,fp.size)(activeOffers) === 1) {
            return null;
        }
        var lastViewedProductType = lastViewedProduct === null || lastViewedProduct === void 0 ? void 0 : lastViewedProduct.type;
        // @ts-expect-error - Automatic, Please fix when editing this file
        var heroOffer = (0,filter_offers_by_product_type/* default */.Z)(lastViewedProductType, activeOffers);
        var offersWithoutHero = (0,fp.reject)({
            id: heroOffer === null || heroOffer === void 0 ? void 0 : heroOffer.id
        }, activeOffers);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(tile/* default */.Z, {
            heading: heading,
            overrideOffers: offersWithoutHero,
            placeholders: offerProps === null || offerProps === void 0 ? void 0 : offerProps.placeholders
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tile/* default */.Z, {
        heading: heading
    });
};
/* harmony default export */ var get_offer_or_perk_tile = (getOfferOrPerkTile);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./src/client/cms/utils/get-cms-data/index.ts
var get_cms_data = __webpack_require__(94711);
// EXTERNAL MODULE: ./src/client/models/table-of-contents/utils/get-table-of-contents-list-by-identifier-query/index.ts
var get_table_of_contents_list_by_identifier_query = __webpack_require__(77192);
;// CONCATENATED MODULE: ./pages/utils/get-why-ahm-query/index.ts






var getWhyAhmQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var query, cmsWhyAhmData, WhyAhmItems;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = (0,get_table_of_contents_list_by_identifier_query/* default */.Z)(constants/* FRAGMENTS.WHY_AHM */.Y.WHY_AHM);
                    return [
                        4,
                        (0,get_cms_data/* default */.Z)(query, {
                            variables: {
                                identifier: "why-ahm"
                            }
                        })
                    ];
                case 1:
                    cmsWhyAhmData = _state.sent();
                    WhyAhmItems = (0,fp.get)("items", (0,fp.head)((0,fp.get)("allTableOfContentsList", cmsWhyAhmData)));
                    return [
                        2,
                        !(0,fp.isEmpty)(WhyAhmItems) ? WhyAhmItems : null
                    ];
            }
        });
    });
    return function getWhyAhmQuery() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var get_why_ahm_query = (getWhyAhmQuery);

// EXTERNAL MODULE: ./src/client/pages/explained-term/detail/utils/get-value-propositon-data/index.ts
var get_value_propositon_data = __webpack_require__(38701);
;// CONCATENATED MODULE: ./src/client/pages/home/utils/get-why-ahm-section/index.ts


var getWhyAhmSection = function(valuePropositionGroups) {
    if ((0,fp.isEmpty)(valuePropositionGroups)) {
        return {};
    }
    var whyAhmSectionGroup = valuePropositionGroups[0];
    if (!whyAhmSectionGroup) {
        return {};
    }
    var item = whyAhmSectionGroup.item;
    var whyAhmSectionTitle = item === null || item === void 0 ? void 0 : item.name;
    var whyAhmTileData = (0,get_value_propositon_data/* default */.Z)(item === null || item === void 0 ? void 0 : item.valuePropositionsReference);
    return {
        whyAhmSectionTitle: whyAhmSectionTitle,
        whyAhmTileData: whyAhmTileData
    };
};
/* harmony default export */ var get_why_ahm_section = (getWhyAhmSection);

// EXTERNAL MODULE: ./src/client/actions/price/index.ts
var price = __webpack_require__(77061);
// EXTERNAL MODULE: ./src/client/models/price/index.ts
var models_price = __webpack_require__(2798);
// EXTERNAL MODULE: ./src/client/actions/product/index.ts
var product = __webpack_require__(15311);
// EXTERNAL MODULE: ./src/client/models/product/index.ts + 32 modules
var models_product = __webpack_require__(43735);
// EXTERNAL MODULE: ./src/client/actions/referrer/index.ts
var referrer = __webpack_require__(26256);
// EXTERNAL MODULE: ./src/client/selectors/select-has-partner-referrer/index.ts
var select_has_partner_referrer = __webpack_require__(93830);
// EXTERNAL MODULE: ./src/client/selectors/select-last-viewed-product/index.ts
var select_last_viewed_product = __webpack_require__(77901);
// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/styles.module.sass
var wrapped_section_styles_module = __webpack_require__(42262);
var wrapped_section_styles_module_default = /*#__PURE__*/__webpack_require__.n(wrapped_section_styles_module);
;// CONCATENATED MODULE: ./src/client/pages/home/index.tsx




























var getPrice = models_price/* default.getPrice */.Z.getPrice;
var getProduct = models_product/* default.getProduct */.Z.getProduct;
var HomePage = function(param) {
    var actions = param.actions, content = param.content, customer = param.customer, isPartnerReferral = param.isPartnerReferral, lastViewedProductId = param.lastViewedProductId, prices = param.prices, products = param.products;
    var router = (0,next_router.useRouter)();
    var params = router.query;
    var serverCookieValue = (0,cookie/* useCookieContext */.f)();
    var memberNumber = (0,fp.get)("id", (0,cookie_for_members/* getCookieForMembers */.a)("health", {
        serverCookieValue: serverCookieValue
    }));
    var hasLastViewedProduct = !(0,fp.isNil)(lastViewedProductId);
    var isHomepageOfferBannerEnabled = (0,esm/* useFeatureIsOn */.cC)(ui.GROWTHBOOK_HOMEPAGE_OFFER_BANNER);
    get_why_ahm_query();
    var lastViewedProduct = hasLastViewedProduct ? getProduct(products, lastViewedProductId) : null;
    var _product = actions.product, loadProduct = _product.load;
    var _price = actions.price, loadPrice = _price.load;
    (0,react.useEffect)(function() {
        if (hasLastViewedProduct && (0,fp.isEmpty)(lastViewedProduct)) {
            loadProduct(lastViewedProductId);
        }
    }, [
        lastViewedProduct,
        lastViewedProductId
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        if (hasLastViewedProduct && !getPrice(prices, lastViewedProductId, customer)) {
            loadPrice(lastViewedProductId, customer);
        }
    }, [
        lastViewedProductId,
        prices
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var source = params.source;
    var valuePropositionGroups = content === null || content === void 0 ? void 0 : content.valueProposition;
    var ref = get_why_ahm_section(valuePropositionGroups), whyAhmSectionTitle = ref.whyAhmSectionTitle, whyAhmTileData = ref.whyAhmTileData;
    (0,react.useEffect)(function() {
        if (source === "raiz") {
            actions.referrer.setHasPartnerReferrer(true);
        }
    }, [
        actions.referrer,
        source
    ]);
    var ref1 = get_hero_section_content(content), heroSectionProps = ref1.heroSectionProps, diversifiedHeroProps = ref1.diversifiedHeroProps;
    var offerProps = {
        activeOffers: (0,fp.get)("activeOffers", content),
        placeholders: (0,fp.get)("placeholders", content)
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* Wrapper */.im, {
        size: "extraExtraLarge",
        children: [
            get_home_hero({
                diversifiedHeroProps: diversifiedHeroProps,
                heroSectionProps: heroSectionProps,
                isPartnerReferral: isPartnerReferral,
                lastViewedProduct: lastViewedProduct,
                lastViewedProductId: lastViewedProductId,
                memberNumber: memberNumber,
                offerProps: offerProps
            }),
            get_offer_or_perk_tile({
                isHomepageOfferBannerEnabled: isHomepageOfferBannerEnabled,
                isPartnerReferral: isPartnerReferral,
                lastViewedProduct: lastViewedProduct,
                offerProps: offerProps,
                serverCookieValue: serverCookieValue
            }),
            whyAhmTileData && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                isBoxed: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                    df: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (wrapped_section_styles_module_default()).horizontalSpacingWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(features_section/* default */.Z, {
                            tiles: whyAhmTileData,
                            title: whyAhmSectionTitle || "Why ahm?",
                            withSimpleBit: false
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_awards, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(content_tiles, {
                items: (0,fp.get)("announcements", content)
            })
        ]
    });
};
var mapDispatchToProps = function(dispatch) {
    return {
        actions: {
            price: (0,redux/* bindActionCreators */.DE)(price/* default */.Z, dispatch),
            product: (0,redux/* bindActionCreators */.DE)(product/* default */.Z, dispatch),
            referrer: (0,redux/* bindActionCreators */.DE)(referrer/* default */.Z, dispatch)
        }
    };
};
var home_mapStateToProps = function(state) {
    return {
        customer: (0,select_customer/* default */.Z)(state),
        isPartnerReferral: (0,select_has_partner_referrer/* default */.Z)(state),
        lastViewedProductId: (0,select_last_viewed_product/* default */.Z)(state),
        prices: state.price.data,
        products: state.product.data
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
/* harmony default export */ var home = ((0,es/* connect */.$j)(home_mapStateToProps, mapDispatchToProps)(HomePage));


// EXTERNAL MODULE: ./src/client/cms/queries/index.ts
var queries = __webpack_require__(56544);
;// CONCATENATED MODULE: ./pages/utils/filter-home-page-banners.ts

var filterHomePageBanners = function(cmsBanners) {
    return (0,fp.filter)(function(banner) {
        return (0,fp.includes)((0,fp.get)("identifier.current", banner), [
            "home-default",
            "home-diversified"
        ]);
    }, (0,fp.get)("allBanner", cmsBanners));
};
/* harmony default export */ var filter_home_page_banners = (filterHomePageBanners);

;// CONCATENATED MODULE: ./pages/utils/use-get-home-banners-query/index.ts



// @ts-expect-error - Automatic, Please fix when editing this file
var useGetHomeBannersQuery = function(param) {
    var shouldSkip = param.shouldSkip;
    var ref = (0,client.useQuery)(queries/* GET_ALL_BANNER_QUERY */.rL, {
        skip: shouldSkip
    }), cmsBannerData = ref.data, loading = ref.loading;
    var banners = filter_home_page_banners(cmsBannerData);
    return {
        banners: banners,
        loading: loading
    };
};
/* harmony default export */ var use_get_home_banners_query = (useGetHomeBannersQuery);

// EXTERNAL MODULE: ./pages/utils/use-get-offers-content/index.ts
var use_get_offers_content = __webpack_require__(68085);
// EXTERNAL MODULE: ./pages/utils/use-get-table-of-contents-lists/index.ts
var use_get_table_of_contents_lists = __webpack_require__(80263);
;// CONCATENATED MODULE: ./pages/index.page.tsx









var index_page_HomePage = function(param) {
    var serverSideOffers = param.activeOffers, serverSideAnnouncements = param.announcements, serverSideBanners = param.banners, serverSidePlaceholders = param.placeholders, serverSideValueProposition = param.valueProposition;
    var shouldSkip = (0,get_should_skip_client_side_request/* default */.Z)();
    var ref = use_get_home_banners_query({
        shouldSkip: shouldSkip
    }), banners = ref.banners, isBannersLoading = ref.loading;
    var ref1 = (0,use_get_table_of_contents_lists/* default */.Z)({
        fragment: constants/* FRAGMENTS.ANNOUNCEMENTS */.Y.ANNOUNCEMENTS,
        shouldSkip: shouldSkip,
        slug: "announcements"
    }), announcements = ref1.data, isAnnouncementsLoading = ref1.loading;
    var ref2 = (0,use_get_table_of_contents_lists/* default */.Z)({
        fragment: constants/* FRAGMENTS.WHY_AHM */.Y.WHY_AHM,
        shouldSkip: shouldSkip,
        slug: "why-ahm"
    }), valueProposition = ref2.data, isValuePropositionLoading = ref2.loading;
    var ref3 = (0,use_get_offers_content/* default */.Z)({
        shouldSkip: shouldSkip
    }), activeOffers = ref3.activeOffers, placeholders = ref3.placeholders, isOfferContentLoading = ref3.loading;
    var content = {
        activeOffers: shouldSkip || isOfferContentLoading ? serverSideOffers : activeOffers,
        announcements: shouldSkip || isAnnouncementsLoading ? serverSideAnnouncements : announcements,
        banners: shouldSkip || isBannersLoading ? serverSideBanners : banners,
        placeholders: shouldSkip || isOfferContentLoading ? serverSidePlaceholders : placeholders,
        valueProposition: shouldSkip || isValuePropositionLoading ? serverSideValueProposition : valueProposition
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(home, {
        content: content
    });
};
var __N_SSG = true;
// @ts-expect-error - Automatic, Please fix when editing this file
function WrappedPage(props) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    return (0,growth_book/* GrowthBookPageWrapper */.CT)(props, index_page_HomePage);
}


/***/ }),

/***/ 68085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _src_client_cms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28937);
/* harmony import */ var _src_client_components_offers_logic_use_get_active_promo_offer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8235);
/* harmony import */ var _src_client_components_offers_logic_use_get_all_placeholders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38153);



// @ts-expect-error - Automatic, Please fix when editing this file
var useGetOffersContent = function(param) {
    var shouldSkip = param.shouldSkip;
    var ref = (0,_src_client_components_offers_logic_use_get_active_promo_offer__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        skip: shouldSkip,
        targetSegment: _src_client_cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .TARGET_SEGMENT.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE */ .TZ.LOOKING_FOR_PRIVATE_HEALTH_INSURANCE
    }), activeOffers = ref.activeOffers, isLoadingOffers = ref.loading;
    var ref1 = (0,_src_client_components_offers_logic_use_get_all_placeholders__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        skip: shouldSkip
    }), placeholders = ref1.placeholders, isLoadingPlaceHolders = ref1.loading;
    return {
        activeOffers: activeOffers,
        loading: isLoadingOffers || isLoadingPlaceHolders,
        placeholders: placeholders
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetOffersContent);


/***/ }),

/***/ 80263:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _src_client_cms_utils_use_table_of_contents__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30329);

// @ts-expect-error - Automatic, Please fix when editing this file
var useGetTableOfContentsLists = function(param) {
    var fragment = param.fragment, shouldSkip = param.shouldSkip, slug = param.slug;
    var ref = (0,_src_client_cms_utils_use_table_of_contents__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({
        fragment: fragment,
        skip: shouldSkip,
        slug: slug
    }), items = ref.items, loading = ref.loading;
    return {
        data: items,
        loading: loading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetTableOfContentsLists);


/***/ }),

/***/ 15311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23094);
/* harmony import */ var _models_product__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43735);



/**
 * Load products into state.
 *
 * @param {string|string[]} productIds - One or a list of product ids.
 * @returns {object} Action.
 */ // @ts-expect-error - Automatic, Please fix when editing this file
function load(productIds) {
    var array = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isString)(productIds) ? [
        productIds
    ] : productIds;
    return {
        productIds: array,
        // @ts-expect-error - Automatic, Please fix when editing this file
        promise: function(api) {
            return _models_product__WEBPACK_IMPORTED_MODULE_1__/* ["default"].loadProducts */ .Z.loadProducts(api, array);
        },
        types: [
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD */ .F9,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_SUCCESS */ .cx,
            _action_types__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCT_LOAD_FAIL */ .w2
        ]
    };
}
/* harmony default export */ __webpack_exports__["Z"] = ({
    load: load
});


/***/ }),

/***/ 26256:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _action_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23094);

// @ts-expect-error - Automatic, Please fix when editing this file
var setAttribution = function(attributionId) {
    return {
        attributionId: attributionId,
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .SET_ATTRIBUTION */ .M2
    };
};
// @ts-expect-error - Automatic, Please fix when editing this file
var setHasPartnerReferrer = function(hasPartnerReferrer) {
    return {
        hasPartnerReferrer: hasPartnerReferrer,
        type: _action_types__WEBPACK_IMPORTED_MODULE_0__/* .SET_HAS_PARTNER_REFERRER */ .Gd
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    setAttribution: setAttribution,
    setHasPartnerReferrer: setHasPartnerReferrer
});


/***/ }),

/***/ 94711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10092);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75624);
/* harmony import */ var _utils_create_apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85669);
/* harmony import */ var _utils_create_apollo_client__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_utils_create_apollo_client__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_get_sanity_uri__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72833);
/* harmony import */ var _utils_get_sanity_uri__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_utils_get_sanity_uri__WEBPACK_IMPORTED_MODULE_3__);




// @ts-expect-error - Automatic, Please fix when editing this file

// @ts-expect-error - Automatic, Please fix when editing this file

var getCmsData = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(query, options) {
        var variables, sanityConfig, sanityClient, result;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    variables = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("variables", options);
                    sanityConfig = _config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].get */ .Z.get("sanity");
                    sanityClient = _utils_create_apollo_client__WEBPACK_IMPORTED_MODULE_2___default()(_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, sanityConfig.dataset, "published", _utils_get_sanity_uri__WEBPACK_IMPORTED_MODULE_3___default()(_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z));
                    return [
                        4,
                        sanityClient.query({
                            query: query,
                            variables: variables
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result.data
                    ];
            }
        });
    });
    return function getCmsData(query, options) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["Z"] = (getCmsData);


/***/ }),

/***/ 62457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _elements_header_utils_extract_perk_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29561);


// @ts-expect-error - Automatic, Please fix when editing this file
var buildCtaProps = function(perk) {
    var ctaText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("descriptionTeaser", perk);
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isNil)(ctaText)) {
        ctaText = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("urlObject.name", perk);
    }
    return {
        ctaText: ctaText,
        ctaUrl: (0,_elements_header_utils_extract_perk_url__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(perk)
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (buildCtaProps);


/***/ }),

/***/ 84244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ features_section; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ahmdigital/ui/lib/ahm-ui.js
var ahm_ui = __webpack_require__(37169);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/client/components/sections/features-section/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 auto;\n  @media (min-width: ",
        ") {\n    max-width: 35rem;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 0.5rem;\n  margin-top: 2rem;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var media = ahm_ui/* theme.media */.rS.media;
var DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-773e8259-0"
})(_templateObject(), media.sm);
var CtaWrapper = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-773e8259-1"
})(_templateObject1());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/client/ahm-constants/index.ts + 1 modules
var ahm_constants = __webpack_require__(10453);
// EXTERNAL MODULE: ./src/client/components/sections/features-section/tile/styles.module.sass
var styles_module = __webpack_require__(92139);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/client/components/sections/features-section/tile/cta/index.tsx




var TileCta = function(param) {
    var urlObject = param.urlObject, _isLifeStageSection = param.isLifeStageSection, isLifeStageSection = _isLifeStageSection === void 0 ? false : _isLifeStageSection;
    if (!(urlObject === null || urlObject === void 0 ? void 0 : urlObject.url) || !(urlObject === null || urlObject === void 0 ? void 0 : urlObject.name)) return null;
    return isLifeStageSection ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
        to: urlObject.url,
        variant: [
            "border",
            "white"
        ],
        className: (styles_module_default()).lifeStageButton,
        children: urlObject.name
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Clickable */.P3, {
        to: urlObject.url,
        variant: [
            "marginTopSpacer9"
        ],
        children: urlObject.name
    });
};
/* harmony default export */ var cta = (TileCta);

;// CONCATENATED MODULE: ./src/client/components/sections/features-section/tile/index.tsx








var FeaturesTile = function(param) {
    var image = param.image, summary = param.summary, title = param.title, urlObject = param.urlObject, _withSimpleBit = param.withSimpleBit, withSimpleBit = _withSimpleBit === void 0 ? true : _withSimpleBit;
    var ref;
    var isLifeStageSection = Boolean(urlObject === null || urlObject === void 0 ? void 0 : (ref = urlObject.url) === null || ref === void 0 ? void 0 : ref.startsWith("".concat(ahm_constants/* default.URLS.SALES.REFINE_PRICE */.Z.URLS.SALES.REFINE_PRICE, "?scale=")));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: isLifeStageSection ? (styles_module_default()).lifeStageTileWrapper : (styles_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
            variant: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()((0,_define_property/* default */.Z)({}, (styles_module_default()).lifeStageContentWrapper, isLifeStageSection)),
                    children: [
                        image && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Image */.Ee, {
                            alt: image.alt,
                            src: image.src,
                            className: (styles_module_default()).image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H3, {
                            looksLike: withSimpleBit ? "h4" : "h6",
                            variant: withSimpleBit ? "simpleBit" : undefined,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                                source: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            source: summary
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(cta, {
                    urlObject: urlObject,
                    isLifeStageSection: isLifeStageSection
                })
            ]
        })
    });
};
/* harmony default export */ var features_section_tile = (FeaturesTile);

// EXTERNAL MODULE: ./src/utils/uncap-fp-iterator.ts
var uncap_fp_iterator = __webpack_require__(96852);
// EXTERNAL MODULE: ./src/client/components/sections/wrapped-section/index.tsx
var wrapped_section = __webpack_require__(51878);
;// CONCATENATED MODULE: ./src/client/components/sections/features-section/index.tsx











var FeaturesSection = function(param) {
    var cta = param.cta, description = param.description, title = param.title, tiles = param.tiles, _withBorder = param.withBorder, withBorder = _withBorder === void 0 ? false : _withBorder, _withSimpleBit = param.withSimpleBit, withSimpleBit = _withSimpleBit === void 0 ? true : _withSimpleBit;
    var numberOfTiles = (0,fp.size)(tiles);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(wrapped_section/* default */.Z, {
        withBorder: withBorder,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ahm_ui/* TypeWrapper */.f3, {
                variant: [
                    "center",
                    "marginBottomSpacer7"
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui.H2, {
                        variant: (0,fp.compact)([
                            withSimpleBit && "simpleBit"
                        ]),
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* PortableText */.YI, {
                            source: description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Row */.X2, {
                lgHorizontalAlign: "center",
                children: (0,uncap_fp_iterator/* default */.Z)(fp.map)(function(tile, index) {
                    var ref1;
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ahm_ui/* Col */.JX, {
                        df: numberOfTiles === 4 ? 3 : 4,
                        md: 12,
                        variant: "marginBottomSpacer10",
                        children: /*#__PURE__*/ (0,react.createElement)(features_section_tile, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tile), {
                            key: "".concat((0,fp.kebabCase)((ref = (ref1 = tile.image) === null || ref1 === void 0 ? void 0 : ref1.alt) !== null && ref !== void 0 ? ref : ""), "-").concat(index),
                            withSimpleBit: true
                        }))
                    });
                }, tiles)
            }),
            cta && (cta.onClick || cta.to) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* SpacerWrapper */.Cj, {
                variant: [
                    "marginTopSpacer8",
                    "marginBottomSpacer11"
                ],
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ahm_ui/* Button */.zx, {
                        onClick: cta.onClick,
                        to: cta.to,
                        variant: [
                            "border",
                            "white"
                        ],
                        children: cta.title
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var features_section = (FeaturesSection);


/***/ }),

/***/ 51878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37169);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42262);
/* harmony import */ var _styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_sass__WEBPACK_IMPORTED_MODULE_4__);





var WrappedSection = function(param) {
    var children = param.children, variant = param.variant, withBorder = param.withBorder, withInvert = param.withInvert, withWide = param.withWide, spacerSize = param.spacerSize;
    var section = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .Section */ .$0, {
        variant: [
            "paddingTopSpacer".concat(spacerSize),
            "paddingBottomSpacer".concat(spacerSize),
            (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().section),
            variant
        ],
        children: children
    });
    return withBorder ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .BorderGridContainer */ .sO, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ahmdigital_ui__WEBPACK_IMPORTED_MODULE_1__/* .GridBox */ .zc, {
            padding: "0",
            backgroundColor: withInvert ? "black" : "white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()([
                    (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().horizontalSpacingWrapper),
                    withInvert ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().invert) : null,
                    withWide ? (_styles_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wide) : null, 
                ]),
                children: section
            })
        })
    }) : section;
};
WrappedSection.defaultProps = {
    spacerSize: 3,
    variant: null,
    withBorder: false,
    withInvert: false,
    withWide: false
};
/* harmony default export */ __webpack_exports__["Z"] = (WrappedSection);


/***/ }),

/***/ 38701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51413);


var getValuePropositionData = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flow)((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.take)(3), (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(param) {
    var title = param.name, imageObject = param.imageObject, summary = param.summary, urlObject = param.urlObject;
    return {
        image: (0,_cms_utils_get_image_attributes__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            imageObject: imageObject
        }),
        summary: summary,
        title: title,
        urlObject: urlObject
    };
}));
/* harmony default export */ __webpack_exports__["Z"] = (getValuePropositionData);


/***/ }),

/***/ 93830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);

// @ts-expect-error - Automatic, Please fix when editing this file
var selectHasPartnerReferrer = function(state) {
    return !!(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("referrer.hasPartnerReferrer", state);
};
/* harmony default export */ __webpack_exports__["Z"] = (selectHasPartnerReferrer);


/***/ }),

/***/ 85669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);
// @ts-ignore - Automatic, Please fix when editing this file

var ref = __webpack_require__(46829), ApolloClient = ref.ApolloClient, HttpLink = ref.HttpLink, ApolloLink = ref.ApolloLink;
// @ts-expect-error - Automatic, Please fix when editing this file
var ref1 = __webpack_require__(78230), get = ref1.get, isEmpty = ref1.isEmpty, set = ref1.set;
var InMemoryCache = (__webpack_require__(39879).InMemoryCache);
// @ts-expect-error - Automatic, Please fix when editing this file
var fetch = __webpack_require__(83300);
var setContext = (__webpack_require__(34650)/* .setContext */ .v);
var setAuthHeader = function(param) {
    var isProduction = param.isProduction, token = param.token;
    return setContext(function(_, context) {
        if (isProduction || !token) {
            return context;
        }
        return set("headers.authorization", "Bearer ".concat(token), context);
    });
};
// This creates the CMS client for the server side logic and CMS interactions, with the client having a similar copy of this
// code. Any changes done to this file needs to be replicated on the server's CMS client as well (particularly the createClient
// and getUri methods). These would most probably get combined when Next.js is implemented.
// @ts-expect-error - Automatic, Please fix when editing this file
var createClient = function(config, dataset, mode, uri) {
    var sanityConfig = config.get("sanity");
    var sanityApiToken = process.env.SANITY_API_TOKEN;
    var isProduction = get("NODE_ENV")(config) === "production";
    var cache = new InMemoryCache();
    var fetchPolicy = sanityConfig.fetchPolicy.server;
    var opts = {
        cache: cache,
        connectToDevTools: !isProduction,
        defaultOptions: {
            query: {
                fetchPolicy: fetchPolicy
            },
            watchQuery: {
                fetchPolicy: fetchPolicy
            }
        },
        link: ApolloLink.from([
            // draft documents are only returned with an api token
            setAuthHeader({
                isProduction: isProduction,
                token: sanityApiToken
            }),
            new HttpLink({
                fetch: fetch,
                uri: uri
            }), 
        ]),
        name: "sanity-sales",
        ssrMode: true
    };
    return new ApolloClient(opts);
};
module.exports = createClient;


/***/ }),

/***/ 41763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10453);


var EXTRAS_ONLY_OFFER_TYPE = "extras-only";
var HOSPITAL_ONLY_OFFER_TYPE = "hospital-only";
var filterOffersByProductType = function(lastViewedProductType, offers) {
    var ref = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.groupBy)(function(offer) {
        var ref;
        var offerId = offer === null || offer === void 0 ? void 0 : (ref = offer.identifier) === null || ref === void 0 ? void 0 : ref.current;
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(EXTRAS_ONLY_OFFER_TYPE, offerId)) {
            return "extrasOnlyOffers";
        }
        if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(HOSPITAL_ONLY_OFFER_TYPE, offerId)) {
            return "hospitalOnlyOffers";
        }
        return "otherOffers";
    })(offers), extrasOnlyOffers = ref.extrasOnlyOffers, hospitalOnlyOffers = ref.hospitalOnlyOffers, otherOffers = ref.otherOffers;
    var prioritisedOffersForProductType = function() {
        if (lastViewedProductType === _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT_TYPE.EXTRAS */ .Z.PRODUCT_TYPE.EXTRAS) {
            return extrasOnlyOffers;
        }
        if (lastViewedProductType === _ahm_constants__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PRODUCT_TYPE.HOSPITAL */ .Z.PRODUCT_TYPE.HOSPITAL) {
            return hospitalOnlyOffers;
        }
        return otherOffers;
    };
    var offerPriorityWhenNoProductTypeMatch = otherOffers || extrasOnlyOffers || hospitalOnlyOffers;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(prioritisedOffersForProductType()) || (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.head)(offerPriorityWhenNoProductTypeMatch);
};
/* harmony default export */ __webpack_exports__["Z"] = (filterOffersByProductType);


/***/ }),

/***/ 84701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47569);

var getFutureDate = function(useFutureEffectiveDate) {
    return useFutureEffectiveDate ? _features_premium_change_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FUTURE_EFFECTIVE_DATE */ .Z.FUTURE_EFFECTIVE_DATE : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getFutureDate);


/***/ }),

/***/ 78687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ahm_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10453);

var _URLS = _ahm_constants__WEBPACK_IMPORTED_MODULE_0__/* ["default"].URLS */ .Z.URLS, EXPLAINED = _URLS.SALES.EXPLAINED;
var getLinkForExplainedTerm = function(param) {
    var detailsTeaser = param.detailsTeaser, identifier = param.identifier, urlObject = param.urlObject;
    var urlName = urlObject === null || urlObject === void 0 ? void 0 : urlObject.name;
    var url = urlObject === null || urlObject === void 0 ? void 0 : urlObject.url;
    if (urlName && url) {
        return {
            link: url,
            linkText: urlName
        };
    }
    var slug = identifier === null || identifier === void 0 ? void 0 : identifier.current;
    var ctaPath = slug ? "".concat(EXPLAINED, "/").concat(slug) : null;
    if (ctaPath && detailsTeaser) {
        return {
            link: ctaPath,
            linkText: detailsTeaser
        };
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (getLinkForExplainedTerm);


/***/ }),

/***/ 72833:
/***/ (function(module) {

"use strict";
// @ts-expect-error - Automatic, Please fix when editing this file

var getSanityUri = function(config) {
    var sanityConfig = config.get("sanity");
    var FILTERED_SUFFIX = "_filtered";
    var dataset = "".concat(sanityConfig.dataset).concat(sanityConfig.useFiltered ? FILTERED_SUFFIX : "");
    return "https://".concat(sanityConfig.projectId, ".api").concat(sanityConfig.useCdn ? "cdn" : "", ".sanity.io/v1/graphql/").concat(dataset, "/").concat(sanityConfig.tag);
};
module.exports = getSanityUri;


/***/ }),

/***/ 14033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _cms_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28937);
/* harmony import */ var _cms_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6465);


var getShouldSkipClientSideRequest = function() {
    var useLiveFiltering = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].useLiveFiltering */ .Z.useLiveFiltering, asAtDate = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].asAtDate */ .Z.asAtDate, asAtTime = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].asAtTime */ .Z.asAtTime, dataset = _cms_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].dataset */ .Z.dataset;
    return !useLiveFiltering || asAtDate === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .NOW */ .Kp && asAtTime === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .MIDDAY */ .T3 && dataset === _cms_constants__WEBPACK_IMPORTED_MODULE_0__/* .DATASET.PRODUCTION */ .tz.PRODUCTION;
};
/* harmony default export */ __webpack_exports__["Z"] = (getShouldSkipClientSideRequest);


/***/ }),

/***/ 591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);


// @ts-expect-error - Automatic, Please fix when editing this file
var isProductBestSeller = function(param) {
    var scale = param.scale, parentProductId = param.parentProductId, productId = param.productId, productType = param.productType;
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.some)(function(id) {
        return id === (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.get)("".concat(productType, ".").concat(scale), _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.BEST_SELLERS_PRODUCT_LIST);
    }, (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.compact)([
        parentProductId,
        productId
    ]));
};
/* harmony default export */ __webpack_exports__["Z"] = (isProductBestSeller);


/***/ }),

/***/ 59794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export serviceMapper */
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _get_future_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84701);
/* harmony import */ var _is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(591);
/* harmony import */ var _models_price__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2798);
/* harmony import */ var _models_url__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26789);





// @ts-expect-error - Automatic, Please fix when editing this file
var serviceMapper = function(feature) {
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(param) {
        var id = param.id, name = param.name;
        return {
            id: id,
            name: name
        };
    }, feature.services);
};
var prepareProductForProductTile = function(param) {
    var customer = param.customer, frequency = param.frequency, prices = param.prices, mlsAmount = param.mlsAmount, useFutureEffectiveDate = param.useFutureEffectiveDate;
    return(// @ts-expect-error - Automatic, Please fix when editing this file
    function(product) {
        if (!product) {
            return null;
        }
        var id = product.id, additionalDetails = product.additionalDetails, charges = product.charges, content = product.content, ctaText = product.ctaText, extras = product.extras, features = product.features, hospital = product.hospital, hospitalTier = product.hospitalTier, name = product.name, rank = product.rank, type = product.type, ctaProductId = product.ctaProductId, parentProductId = product.parentProductId, unavailableWithExcessInfo = product.unavailableWithExcessInfo;
        var scale = customer.scale;
        var date = (0,_get_future_date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(useFutureEffectiveDate);
        var price = _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getPrice */ .Z.getPrice(prices, id, customer, {
            date: date
        });
        var priceObject = price ? _models_price__WEBPACK_IMPORTED_MODULE_3__/* ["default"].getAmountAsObject */ .Z.getAmountAsObject(price, frequency) : undefined;
        var saving = mlsAmount && priceObject ? Math.max(mlsAmount - parseFloat("".concat(priceObject.dollars, ".").concat(priceObject.cents)), 0) : undefined;
        var hospitalFeatured = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.getOr)([], "hospital.featured", product);
        var hospitalServices = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.flatMap)(serviceMapper, hospitalFeatured);
        return {
            additionalDetails: additionalDetails,
            charges: charges,
            content: content,
            ctaText: ctaText,
            extras: extras,
            features: features,
            frequency: frequency,
            hospital: hospital,
            hospitalTier: hospitalTier,
            id: id,
            isAvailable: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.includes)(scale, product.scales.supported),
            isBestSeller: (0,_is_product_best_seller__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
                parentProductId: parentProductId,
                productId: id,
                productType: type,
                scale: scale
            }),
            name: name,
            price: priceObject,
            rank: rank,
            saving: saving,
            scale: customer.scale,
            services: hospitalServices,
            type: type,
            unavailableWithExcessInfo: unavailableWithExcessInfo,
            url: _models_url__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getProductUrl */ .Z.getProductUrl(ctaProductId || id)
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (prepareProductForProductTile);



/***/ }),

/***/ 2112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93590);




var sortTiles = function(tiles, tileVariant) {
    if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isEmpty)(tiles) || !(0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.isArray)(tiles)) {
        return [];
    }
    var rows = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.chunk)(2)(tiles);
    return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(row) {
        return (0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.map)(function(tile) {
            if ((0,lodash_fp__WEBPACK_IMPORTED_MODULE_0__.size)(row) === 1) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tile), {
                    variant: _ahm_constants_ui__WEBPACK_IMPORTED_MODULE_1__.TILE_VARIANTS.FULL_WIDTH
                });
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, tile), {
                variant: tileVariant
            });
        })(row);
    })(rows);
};
/* harmony default export */ __webpack_exports__["Z"] = (sortTiles);


/***/ }),

/***/ 69076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ GrowthBookPageWrapper; }
/* harmony export */ });
/* unused harmony exports generateGrowthBookSSRProps, injectGrowthBookProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10092);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78230);
/* harmony import */ var lodash_fp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_fp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81361);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _src_client_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75624);









// @ts-expect-error - Automatic, Please fix when editing this file
var generateGrowthBookSSRProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var req, resolvedUrl, gbClientId, host;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            req = param.req, resolvedUrl = param.resolvedUrl;
            gbClientId = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("cookies.gbClientId")(req);
            host = (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.get)("headers.host")(req);
            return [
                2,
                (0,_growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_2__/* .getGrowthBookSSRData */ .R$)({
                    apiHost: _src_client_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("growthbook:apiHost"),
                    attributes: {
                        id: gbClientId || "",
                        url: "".concat(host).concat(resolvedUrl)
                    },
                    clientKey: _src_client_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("growthbook:clientKey")
                })
            ];
        });
    });
    return function generateGrowthBookSSRProps(_) {
        return _ref.apply(this, arguments);
    };
}();
// @ts-expect-error - Automatic, Please fix when editing this file
var injectGrowthBookProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(param) {
        var context, props, growthBookData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    context = param.context, props = param.props;
                    return [
                        4,
                        generateGrowthBookSSRProps(context)
                    ];
                case 1:
                    growthBookData = _state.sent();
                    return [
                        2,
                        {
                            props: (0,lodash_fp__WEBPACK_IMPORTED_MODULE_1__.set)("growthBookData", growthBookData, props)
                        }
                    ];
            }
        });
    });
    return function injectGrowthBookProps(_) {
        return _ref.apply(this, arguments);
    };
}();
var GrowthBookPageWrapper = function(props, Component) {
    var growthBookData = props.growthBookData, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(props, [
        "growthBookData"
    ]);
    // This is required once at the top of the SSR page
    (0,_growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_2__/* .useGrowthBookSSR */ .jL)(growthBookData);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, rest));
};


/***/ }),

/***/ 92139:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","image":"styles_image__Oz7B8","wrapper":"styles_wrapper__MRbsp","lifeStageTileWrapper":"styles_lifeStageTileWrapper__PQS6_","lifeStageContentWrapper":"styles_lifeStageContentWrapper__7Jhpj","lifeStageButton":"styles_lifeStageButton__J7odZ"};

/***/ }),

/***/ 42262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","section":"styles_section__O7WkK","horizontalSpacingWrapper":"styles_horizontalSpacingWrapper__zwDaO","invert":"styles_invert__K85Fh","wide":"styles_wide__gsza_"};

/***/ }),

/***/ 54870:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"baseFontFamily":"proxima-nova,\"Helvetica Neue\",Helvetica Arial,sans-serif","baseFontSize":"16px","baseFontSizeSmall":"14px","black":"#000","blue":"#2598e6","blueDark":"#1561e6","blueTink":"#edf3f6","dashedBorderWidth":"4px","fontWeightBold":"700","fontWeightRegular":"400","green":"#0a5","greenDark":"#308654","greenTint":"#ecf6ed","grey10":"#f6f6f6","grey20":"#ccc","grey30":"#aaa","grey40":"#888","grey50":"#666","grey60":"#444","grey70":"#222","inputMinWidth":"18rem","inputSizeLg":"rem(480px)","inputSizeMd":"rem(320px)","inputSizeSm":"rem(160px)","inputSizeXl":"rem(544px)","magenta":"#bb2fb2","orange":"#ec8e00","productPanelGutter":"8px","purple":"#9855d4","purpleDark":"#734098","purpleTint":"#fcf5ff","radius":"3px","red":"#e62525","redDark":"#b50002","redTint":"#fcf2f2","sectionSpacing":"rem(60px)","textBlack":"#000","textWhite":"#fff","white":"#fff","zIndexFooter":"700","imageWrapper":"styles_imageWrapper__PQZy2","image":"styles_image__pKb10","section":"styles_section__BXVwa"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6950,8761,6964,1849,4329,9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);